import { platformApiSlice } from "./platformApiSlice";

export const platformIssuesApiSlice = platformApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPlatformIssues: builder.query({
      query: ({ useProd = false }) => ({
        url: "/api/v1/issues/",
        params: { use_prod: useProd },
      }),
      providesTags: ["Issues"],
    }),
    getPlatformIssueById: builder.query({
      query: ({ issueId, useProd = false }) => ({
        url: `/api/v1/issues/${issueId}`,
        params: { use_prod: useProd },
      }),
      providesTags: (result, error, { issueId }) => [{ type: "Issues", id: issueId }],
    }),
    getPlatformIssuesByScanId: builder.query({
      query: ({ scanId, useProd = false }) => ({
        url: `/api/v1/issues/scan/${scanId}`,
        params: { use_prod: useProd },
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((issue) => ({
                type: "Issues",
                id: issue.issue_id || issue.id,
              })),
              "Issues",
            ]
          : ["Issues"],
    }),
    createPlatformIssue: builder.mutation({
      query: ({ issue, useProd = false }) => ({
        url: "/api/v1/issues/",
        method: "POST",
        body: issue,
        params: { use_prod: useProd },
      }),
      invalidatesTags: ["Issues"],
    }),
    upsertPlatformIssue: builder.mutation({
      query: ({ scanId, issue, useProd = false }) => ({
        url: `/api/v1/issues/upsert/${scanId}`,
        method: "POST",
        body: issue,
        params: { use_prod: useProd },
      }),
      invalidatesTags: ["Issues"],
    }),
    bulkUpsertPlatformIssues: builder.mutation({
      query: ({ scanId, issues, useProd = false }) => ({
        url: `/api/v1/issues/bulk-upsert/${scanId}`,
        method: "POST",
        body: { issues },
        params: { use_prod: useProd },
      }),
      invalidatesTags: ["Issues"],
    }),
    updatePlatformIssue: builder.mutation({
      query: ({ issueId, issue, useProd = false }) => ({
        url: `/api/v1/issues/${issueId}`,
        method: "PUT",
        body: issue,
        params: { use_prod: useProd },
      }),
      invalidatesTags: (result, error, { issueId }) => [{ type: "Issues", id: issueId }, "Issues"],
    }),
    updatePlatformIssueStatus: builder.mutation({
      query: ({ issueId, status, useProd = false }) => ({
        url: `/api/v1/issues/${issueId}/status`,
        method: "PUT",
        body: { status },
        params: { use_prod: useProd },
      }),
      invalidatesTags: (result, error, { issueId }) => [{ type: "Issues", id: issueId }, "Issues"],
    }),
    deletePlatformIssue: builder.mutation({
      query: ({ issueId, useProd = false }) => ({
        url: `/api/v1/issues/${issueId}`,
        method: "DELETE",
        params: { use_prod: useProd },
      }),
    }),
  }),
});

export const {
  useGetPlatformIssuesQuery,
  useGetPlatformIssueByIdQuery,
  useGetPlatformIssuesByScanIdQuery,
  useCreatePlatformIssueMutation,
  useUpdatePlatformIssueMutation,
  useUpdatePlatformIssueStatusMutation,
  useDeletePlatformIssueMutation,
  useUpsertPlatformIssueMutation,
  useBulkUpsertPlatformIssuesMutation,
} = platformIssuesApiSlice;
